import type { RequestStatus, GenericError } from '@skynet/data-ws-core';

export enum TradingApiCommands {
  Trader = 'Trader',
  // Balance = 'Balance',
  Token = 'Token',
  Error = 'Error',
  CreateESAPIKey = 'CreateESAPIKey',
  DeleteESAPIKey = 'DeleteESAPIKey',
  UpdateESAPIKey = 'UpdateESAPIKey',
  SupportedExchanges = 'supportedExchanges',
}

export enum TaskTypes {
  TWAP = 1,
  Conservative = 2,
  VWAP = 3,
  DEXTWAP = 10,
}

export enum TaskActions {
  Buy = 0,
  Sell = 1,
}

export enum TaskRandomizeValues {
  Disabled = 0,
  Enabled = 1,
}

export interface TradingApiKeyItem {
  id: number;
  key: string;
  name: string;
  accountID: number;
  smallTokens: boolean;
  error: string | null;
  pair: string | null;
  taskType: TaskTypes | null;
  walletAddress: string;
}

export interface ExchangeItem {
  id: string | number | symbol;
  name: string;
  comment: string | null;
  video: string | null;
  ips: string | null;
  pub?: { length: number; mask: string };
  secret?: { length: number; mask: string };
  passphrase?: { label?: string; numbersOnly?: boolean; optional?: boolean };
  /** Minimum order size in USD from the Exchanges API, or `null` when unset. */
  minOrderSize: number | null;
  crypted?: boolean;
}

export type ExchangeObjItems = Record<string, ExchangeItem>;

export interface InitialNewValuesApiKey {
  AccountID: string;
  apiKey: string;
  ID: number;
  passPhrase?: string;
  apiSecret: string;
  exchangeID: number;
}

export interface TradingApiKeysState {
  error: null | GenericError;
  requestStatus: RequestStatus;
  resAddAPIKeyStatus: RequestStatus;
  resUpdateAPIKeyStatus: RequestStatus;
  resDeleteAPIKeyStatus: RequestStatus;
  list: TradingApiKeyItem[];
  targetAccount: string | null;
  instruments: [string, number][];
  selectedExchange: number | undefined;
  supportedExchanges: number[];
  supportedExchangesStatus: RequestStatus;
  isLoadingInvestor: RequestStatus;
  isLoadingTickers: boolean;
}

export interface AddApiKeyPayload {
  apiKey: string;
  apiSecret: string;
  exchangeID: number;
  optional?: string;
  passPhrase?: string;
}

export interface UpdateApiKeyPayload {
  accountID?: number;
  apiKey: string;
  apiSecret: string;
  exchangeID: number;
  optional?: string;
  passPhrase?: string;
}

export interface AvailableBalance {
  token: string;
  volume: number;
}
